import EvaluationSetting from "./KrEvaluationSetting.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrEvaluationSetting = install(EvaluationSetting); // 生成带有 install 方法的组件

export default KrEvaluationSetting;
